<template>
  <div class="telegram-success">
    <h3 class="telegram-success__title">{{$tMailing('Telegram mailing verification')}}</h3>
    <div class="text">
      <ol class="telegram-success__steps">
        <li>{{$tMailing('Go to telegram bot')}}
          <a href="tg://resolve?domain=jobiancom_news_bot">
            @jobiancom_news_bot
          </a>
        </li>
        <li>{{$tMailing(`Push "Start"`)}}</li>
        <li>{{$tMailing(`Send secure code`)}}" <b class="telegram-success__code">{{code}}</b></li>
      </ol>
    </div>
<!--    <button @click.prevent="$vModal.close('telegram-success')" class="telegram-success__btn  base-btn  base-btn&#45;&#45;outline-grey">Ok</button>-->
  </div>
</template>

<script>
  export default {
    props: {
      code: {
        type: Number,
        required: true
      }
    },
    data() {
      return {

      }
    }
  }
</script>

<style lang="less">

</style>